import { fillParentContainer } from 'fancy-textfill';
import whenDomReady from 'when-dom-ready';
import debounce from 'lodash/debounce';

const activitesText = document.querySelectorAll('.js-activity-title');

if (activitesText.length > 0) {
  window.addEventListener('resize', debounce(initialiseText, 100));
}

function initialiseText() {
  Array.forEach(activitesText, element => {
    fillParentContainer(element, {
      maxFontSize: 36,
      minFontSize: 24,
      maxHeight: $(element).height(),
      maxLineHeight: 2,
    });
  });
}

whenDomReady().then(initialiseText);
